import * as React from 'react';

import Skeleton from 'react-loading-skeleton';

import {
  Container,
  LayoutSkeletonLeft,
  LayoutSkeletonRight,
  TitleRow,
} from './scan-and-pay-layout.styled';

export const ScanAndPayLayoutSkeleton: React.FC = () => {
  return (
    <Container data-testid="scan-and-pay-layout-skeleton">
      <TitleRow>
        <LayoutSkeletonLeft>
          <Skeleton width={'100%'} />
        </LayoutSkeletonLeft>
        <LayoutSkeletonRight>
          <Skeleton width={'100%'} />
        </LayoutSkeletonRight>
      </TitleRow>
      <Skeleton count={2} width={'100%'} />
    </Container>
  );
};
